import { TagDomAttribute } from 'tag/ts/tag/model/type/TagDomAttribute';
export const ViewLibrary = {
    SMART_TAG_SKELETON: '<div ' +
        `${TagDomAttribute.SMART_TAG}="$UUID$" ` +
        'style="position: absolute !important;  ' +
        'overflow: hidden !important; ' +
        'width: 100% !important; ' +
        'height: 100% !important; ' +
        'background-color: black !important;">' +
        '<div ' +
        `${TagDomAttribute.CONTENT}="$UUID$" ` +
        'style="position: absolute !important; ' +
        'width: 100% !important; ' +
        'height: 100% !important; ' +
        'background-color: black !important;" ' +
        'class="player-services-smart-tag-content-element">' +
        '</div>' +
        '<div ' +
        `${TagDomAttribute.OVERLAY}="$UUID$" ` +
        'style="position: absolute !important; ' +
        'display: block; ' +
        'top: -10000px; ' +
        'z-index: 1000 !important; ' +
        'width: 100% !important; ' +
        'height: 100% !important; ' +
        'background-color: black !important;">' +
        '</div>' +
        '<div ' +
        `${TagDomAttribute.LOADING_ANIMATION}="$UUID$" ` +
        'style="position: absolute !important; ' +
        'width: 100% !important; ' +
        'height: 100% !important; ' +
        'display: none; ' +
        'justify-content: center !important; ' +
        'align-items: center !important; ' +
        'background-color: rgba( 0, 0, 0, 1 ); ' +
        'z-index: 100 !important;">' +
        '</div>' +
        '</div>',
    ERROR_PANEL: '<div style="' +
        'position:absolute; ' +
        'width:100%; ' +
        'height: 100%; ' +
        'opacity: 0; ' +
        'transition-property: opacity; ' +
        'transition-duration: 500ms; ' +
        'transition-timing-function: ease-out; ' +
        '-moz-user-select: none; ' +
        '-ms-user-select: none; ' +
        '-khtml-user-select: none; ' +
        '-webkit-user-select: none; ' +
        '-webkit-touch-callout: none; ' +
        'user-select: none; ' +
        'font-family: ProximaNovaA-Regular, sans-serif !important; ' +
        'color: white !important; ' +
        'text-align: center !important; ' +
        'font-size: 1.8em; ' +
        '">' +
        '<div class="background-image" style="' +
        'position:absolute; ' +
        'width:100%; ' +
        'height: 100%; ' +
        'background-repeat: no-repeat; ' +
        'background-size: cover; ' +
        'background-position: center; ' +
        'filter: blur(30px); ' +
        '"></div>' +
        '<div class="gradient-background" ' +
        'style="' +
        'position:absolute; ' +
        'width:100%; ' +
        'height: 100%; ' +
        'background: rgba(0, 0, 0, 0); ' +
        'background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
        'background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
        'background: -o-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
        'background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
        'background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
        'filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#4c4c4c\', endColorstr=\'#131313\', GradientType=0); ' +
        '"></div>' +
        '<div style="' +
        'position:absolute; ' +
        'width:100%; ' +
        'height: 100%; ' +
        'display: flex; ' +
        'justify-content:center; ' +
        'align-items:center; ' +
        '">' +
        '<div style="position: relative; width: 80%;" class="smart-tag-error-panel-content">$MESSAGE$</div>' +
        '</div>' +
        '</div>'
};
